import { Component, OnInit, Input, HostListener } from '@angular/core';
import { Anime, Video } from 'app/core/models/core.model';

@Component({
  selector: 'app-box',
  templateUrl: './box.component.html',
  styleUrls: ['./box.component.scss']
})
export class BoxComponent implements OnInit {
  @Input() data: Anime | Video;
  @Input() anime?: string;
  constructor() { }

  ngOnInit() {
  }

  isAnime(data: Anime | Video) {
    return data['Ep'] == null;
  }
}
